export enum EChoirLevel {
    BIGINNER = 1,
    INTERMEDIATE = 2,
    ADVANCED = 3,
}

export enum EChoirGoal {
    CONCERT = 1,
    RECORDING = 2,
    JOYFUL_MUSIC = 3,
    BLATT_NIGHT = 4,
}

export enum ERepertoirNature {
    CHURCH = 1,
    SECULAR = 2,
}

export enum EChoirStyle {
    CLASSICAL_CHOIR = 1,
    RENAISSANCE_MADRIGAL = 2,
    ORATORIO = 3,
    MOTET = 4,
    GOSPEL = 5,
    POP = 6,
    ROCK = 7,
    JAZZ = 8,
    FOLK = 9,
    WORLD = 10,
    MODERN_CHOIR = 11,
    EXPERIMENTAL = 12,
    ELECTRONIC = 13,
    OTHER = 14,
}

export enum EWayOfSinging {
    SCORE = 1,
    BY_HEART = 2,
}

export enum EChoirDenomination {
    CATHOLIC = 1,
    REFORMED = 2,
    LUTHERAN = 3,
    GREEK_CATHOLIC = 4,
    BAPTIST = 5,
    METHODIST = 6,
}

export interface ILocationData {
    postal_code?: string;
    country?: string;
    locality?: string;
    sublocality?: string;
}

export interface IChoirLocation {
    name: string;
    address: string;
    data: ILocationData;
    geometry: {
        type: 'Point',
        coordinates: [number, number],
    }
}

export const CHOIR_VOICES = ['S', 'S1', 'S2', 'M', 'A', 'A1', 'A2', 'T', 'T1', 'T2', 'B', 'B1', 'B2'] as const;

export type TChoirVoice = typeof CHOIR_VOICES[number];

export interface IChoirMetaGeneral {
    rehearsalLocation?: IChoirLocation;
    level?: EChoirLevel;
    forProject?: boolean;
    goal?: EChoirGoal[];
    description?: string;
    repertoirNature?: ERepertoirNature[];
    style?: EChoirStyle[];
    acapella?: boolean;
    wayOfSinging?: EWayOfSinging;
    denomination?: EChoirDenomination;
    wantedVoices?: TChoirVoice[];
}